<template>
    <div id="calc-box">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "CalcBox"
    }
</script>

<style scoped>

</style>
